import React from "react";
import locationImg from "../../Assets/Contact/location.png";
import callImg from "../../Assets/Contact/call.png";
import mailImg from "../../Assets/Contact/mail.png";
import { BsBoxSeamFill } from "react-icons/bs";
import { IoMail } from "react-icons/io5";
import { IoMdCall } from "react-icons/io";
import { FaUser } from "react-icons/fa";

const ConnectionInfo = () => {
  return (
    <>
      <div className="p-4 sm:p-6 md:p-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Contact Section  */}
          <div>
            <div className="bg-blue-300 rounded-md">
              <p className="text-center text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-medium p-3">
                Get In Touch With Us
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 text-center">
              <div className="flex flex-col gap-4 items-center justify-center py-4 border-r border-b">
                <div>
                  <img src={callImg} alt="" />
                </div>
                <div>
                  <p className="font-semibold text-xl">Phone Number</p>
                </div>
                <div className="w-3/4 font-semibold">
                  <p>+91 9337233933, +91 7326979740, +91 9583146761</p>
                </div>
              </div>

              <div className="flex flex-col gap-4 items-center justify-center py-4 border-l border-b">
                <div>
                  <img src={mailImg} alt="" />
                </div>
                <div>
                  <p className="font-semibold text-xl">Email</p>
                </div>
                <div className="lg:font-medium xl:font-semibold w-full">
                  <p>icvcerification2011@gmail.com</p>
                </div>
              </div>

              <div className="flex flex-col gap-4 items-center justify-center py-4 border-t border-r ">
                <div>
                  <img src={locationImg} alt="" />
                </div>
                <div>
                  <p className="font-semibold text-xl">Rourkela</p>
                </div>
                <div className="w-3/4 font-semibold">
                  <p>M/44, 2nd Floor, Basanti Colony, Rourkela, Pin- 769012</p>
                </div>
              </div>

              <div className="flex flex-col gap-4 items-center justify-center py-4 border-t border-l ">
                <div>
                  <img src={locationImg} alt="" />
                </div>
                <div>
                  <p className="font-semibold text-xl">Jaydeb Vihar</p>
                </div>
                <div className="w-3/4 font-semibold">
                  <p>M/44, 2nd Floor, Basanti Colony, Rourkela, Pin- 769012</p>
                </div>
              </div>
            </div>
          </div>

          {/* Form Section  */}
          <div>
            <div className="bg-blue-300 rounded-md">
              <p className="text-center text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-medium p-3">
                Contact Us
              </p>
            </div>
            <div className="p-4">
              <form className="space-y-3 sm:space-y-4 md:space-y-5">
                {/* First Name and Last Name in Flex Row */}
                <div className="flex flex-col md:flex-row gap-3 sm:gap-4">
                  <div className="flex-1 rounded-lg bg-gray-50 px-3 py-2 md:py-3 flex items-center gap-3 border border-gray-200 focus-within:border-[#29AAE1] transition-colors">
                    <div className="text-gray-500">
                      <FaUser className="text-gray-500" />
                    </div>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      className="bg-transparent outline-none w-full text-gray-700 placeholder-gray-400 text-sm md:text-base"
                      placeholder="First Name"
                      required
                    />
                  </div>
                  <div className="flex-1 rounded-lg bg-gray-50 px-3 py-2 md:py-3 flex items-center gap-3 border border-gray-200 focus-within:border-[#29AAE1] transition-colors">
                    <div className="text-gray-500">
                      <FaUser className="text-gray-500" />
                    </div>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      className="bg-transparent outline-none w-full text-gray-700 placeholder-gray-400 text-sm md:text-base"
                      placeholder="Last Name"
                      required
                    />
                  </div>
                </div>

                {/* Mobile Number */}
                <div className="rounded-lg bg-gray-50 px-3 py-2 md:py-3 flex items-center gap-3 border border-gray-200 focus-within:border-[#29AAE1] transition-colors">
                  <div className="text-gray-500">
                    <IoMdCall className="text-gray-500" />
                  </div>
                  <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    className="bg-transparent outline-none w-full text-gray-700 placeholder-gray-400 text-sm md:text-base"
                    placeholder="Mobile Number"
                    required
                  />
                </div>

                {/* Email Address */}
                <div className="rounded-lg bg-gray-50 px-3 py-2 md:py-3 flex items-center gap-3 border border-gray-200 focus-within:border-[#29AAE1] transition-colors">
                  <div className="text-gray-500">
                    <IoMail className="text-gray-500" />
                  </div>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="bg-transparent outline-none w-full text-gray-700 placeholder-gray-400 text-sm md:text-base"
                    placeholder="Mail Address"
                    required
                  />
                </div>

                {/* Subject */}
                <div className="rounded-lg bg-gray-50 px-3 py-2 md:py-3 flex items-center gap-3 border border-gray-200 focus-within:border-[#29AAE1] transition-colors">
                  <div className="text-gray-500">
                    <BsBoxSeamFill className="text-gray-500 mb-20 md:mb-24" />
                  </div>
                  <textarea
                    name="subject"
                    id="subject"
                    rows="5"
                    cols="50"
                    className="bg-transparent outline-none w-full text-gray-700 placeholder-gray-400 text-sm md:text-base"
                    placeholder="Subject type here"
                    required
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white tracking-wide font-medium py-2 md:py-3 rounded-lg text-sm md:text-base shadow-md hover:shadow-lg transition-all duration-300"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectionInfo;
